import { ButtonGroup, Button } from '@material-ui/core'
import styled from 'styled-components'

const MapTogglesContainer = styled(ButtonGroup)`
  && {
    align-self: flex-end;
    box-shadow: none;
  }
`

const ToggleButton = styled(Button)`
  && {
    padding: 10px 13px;
    border: ${(props) =>
      props.selected ? '1px solid transparent' : '1px solid rgba(55, 111, 139, 0.2)'};
    background: ${(props) => (props.selected ? '#5BBBDB' : 'white')};

    :hover {
      border: 1px solid rgba(55, 111, 139, 0.6);
      background: ${(props) => (props.selected ? '#5BBBDB' : 'white')};
    }
  }
`

export { MapTogglesContainer, ToggleButton }
